/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  VStack,
  ModalHeader,
  ModalCloseButton,
  Select,
  ModalFooter,
  HStack,
} from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getCity, getState } from '@partiu/api/club/api';
import { Button } from '../../../components/atoms/Button';
import { useLocationContext } from '../../../contexts/LocationProvider';

export function LocationModal({
  isOpen,
  onClose,
}: {
  mode?: string;
  discountId?: number;
  isOpen: boolean;
  link?: string;
  code?: string;
  onClose: () => void;
}) {
  const { localModule, colors } = useTheme();
  const { forcedLocation, setForcedLocation } = useLocationContext();
  const [location, setLocation] = useState<any>({});

  const statesQuery = useQuery('state', () => getState());
  const citiesQuery = useQuery(['cities', location.state], () => getCity(location.state || ''), {
    enabled: !!location.state,
  });

  useEffect(() => {
    if (!localModule) return;

    if (forcedLocation) {
      setLocation({
        state: forcedLocation.state,
        city: forcedLocation.city,
      });
    }
  }, [localModule, forcedLocation]);

  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Trocar Localização</ModalHeader>
        <ModalCloseButton color={colors.primaryColor} />
        <ModalBody>
          <VStack spacing={5}>
            <Select
              value={location.state || ''}
              size="md"
              fontSize={14}
              borderRadius={'20px'}
              onChange={(e) =>
                setLocation({
                  ...location,
                  state: e.target.value,
                })
              }
            >
              <option value="">Selecione um Estado</option>
              {(statesQuery.data || []).map((s: any) => (
                <option key={s.state} value={s.state}>
                  {s.name}
                </option>
              ))}
            </Select>
            <Select
              value={location.city || ''}
              size="md"
              fontSize={14}
              borderRadius={'20px'}
              onChange={(e) =>
                setLocation({
                  ...location,
                  city: e.target.value,
                })
              }
              disabled={!location.state || citiesQuery.isLoading}
            >
              <option value="">Selecione uma Cidade</option>
              {(citiesQuery?.data || [])
                .filter((c: any) => c)
                .map((c: any) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
            </Select>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack width={'100%'} spacing={2}>
            <Button
              borderColor={'#242424'}
              backgroundColor="white"
              color={'#242424'}
              width="30%"
              variant="outline"
              onClick={() => {
                if (setForcedLocation) setForcedLocation(null);
                setLocation({});
                onClose();
              }}
            >
              Limpar
            </Button>
            <Button
              onClick={() => {
                if (setForcedLocation) setForcedLocation(location);
                onClose();
              }}
              width="70%"
              isDisabled={!location.state || !location.city}
            >
              Aplicar
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
